import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addUserEmailIsValid: true,
};
const formAddUserValidationSlice = createSlice({
  name: "formAddUserValidationSlice",
  initialState,
  reducers: {
    setAddUserEmailValidation: (state, action) => {
      state.addUserEmailIsValid = action.payload;
    },
  },
});

export const { setAddUserEmailValidation } = formAddUserValidationSlice.actions;

export default formAddUserValidationSlice.reducer;
